import { adapter, Service } from 'components/system';
import { CustomerImageDataProvider } from 'common/customers/services/customerImageDataProvider';

const CURRENT_VERSION = 1;
/* version 1 example:
{
    styles: {
        backgroundPosition: "-69.3602125px -14.2556534025px",
        backgroundSize: "253.35359999999997px 142.51139999999998px"
    },
    cropperData: {
        points: [
            0: "526",
            1: "108",
            2: "1390",
            3: "972"
        ],
        zoom: 0.2778
    }
}
*/

export class CustomerCropStorageServiceClass extends Service {
    private _customerImageDataProvider: CustomerImageDataProvider;

    static get $name() {
        return 'customerCropStorage';
    }

    static get $inject() {
        return ['$injector'];
    }

    constructor($injector: angular.auto.IInjectorService) {
        super();

        this._customerImageDataProvider = CustomerImageDataProvider.getInstance();
    }

    set(params) {
        params.cropData.version = CURRENT_VERSION;

        const item = {
            active: undefined,
            main: true,
            browserDisplaySettings: JSON.stringify(params.cropData),
            notes: undefined
        };

        return this._customerImageDataProvider
            .update(item, {
                id: params.mainImageId,
                customerId: params.customerId
            })
            .then(() => {
                this.emit('change');
            });
    }

    get(customerId: number): Promise<any> {
        return this._customerImageDataProvider
            .all({}, { customerId: customerId })
            .then(items => {
                const mainImage = items.find(item => item.main);

                if (mainImage && mainImage.browserDisplaySettings) {
                    return JSON.parse(mainImage.browserDisplaySettings);
                } else {
                    return Promise.resolve(null);
                }
            })
            .catch(() => {
                return Promise.resolve(null);
            });
    }
}

adapter.linkService(CustomerCropStorageServiceClass);
